import { j as s } from "../../../jsx-runtime-B6kdoens.js";
import { c as a, f as i } from "../../../create-component-CBAeEoQ6.js";
import { Typography as m } from "../../Typography/index.js";
const c = a(
  "CardTitle",
  i(
    ({ as: r = "p", children: o, className: t, ...e }, p) => /* @__PURE__ */ s.jsx(
      m,
      {
        size: "h3",
        as: r,
        ref: p,
        className: t,
        ...e,
        children: o
      }
    )
  )
);
export {
  c as CardTitle
};
//# sourceMappingURL=index.js.map
